import React from "react";
import classes from "../FitnessPreview.module.scss"

import { Card, CardImg } from "reactstrap";
import PropTypes from "prop-types";


const ImagePlaceholder = () => {
    return (
        <div className="border border-dashed d-flex justify-content-center items-center mt-3">
            <div className="w-100 h-100 d-flex flex-column justify-content-center items-center">
                <div style={{alignItems: "center", textAlign: "center"}}></div>
            </div>
        </div>
    );
}

const ProgramImage = ({ imageUrl = "" }) => {
    return (
        imageUrl === "" ? <ImagePlaceholder /> : 
        <Card className={classes.programImageCard} >
            <CardImg
                src={imageUrl}
                alt="Program"
                className={classes.programImage}
            />
        </Card>
    );
}

ProgramImage.propTypes = {
    imageUrl: PropTypes.string.isRequired,
};

export default ProgramImage;